import React, {PropTypes} from 'react';
import Panel from 'shared/Panel.jsx';
import Submitting from 'shared/Submitting.jsx';
import VirtualEntryContainer from './VirtualEntryContainer.jsx';
import VirtualEntryPaymentModalContainer from './VirtualEntryPaymentModalContainer.jsx';
import DisplayIf from 'shared/DisplayIf.jsx';
import ErrorListContainer from 'shared/error/ErrorListContainer.jsx';
import {formatCurrency} from 'shared/util/formatCurrency';
import CaptainVirtualEntryOptionsContainer from './CaptainVirtualEntryOptionsContainer.jsx';
Number.prototype.formatCurrency = formatCurrency;

const VirtualEntryList = ({
  virtualEventId,
  virtualEntries,
  bowlers,
  teams,
  submitting,
  balance,
  selectedBalance,
  onSaveChangesClick,
  onCaptainDetailsLinkClick,
  onPayBalanceClick,
  onPayBalanceOtherClick,
  enabledWebHooks,
  onWebHooksClick,
  environment
}) => (
  <div> 
    <DisplayIf condition={virtualEntries !== null}>
      <Panel className="panel-primary">
      <div className="row flex vertical-center">
        <div className="col-md-6">
          <h3 className="panel-title"
            style={{display: 'inline-block'}}>
            All Event Balance:
          </h3>
          {` `}
          <h3 className="panel-title"
            style={{display: 'inline-block'}}>
            <span>{`$${balance.formatCurrency(2)}`}</span>
            {' '}
            <small>{`(Amount to Pay - $${selectedBalance.formatCurrency(2)})`}</small>
          </h3>
        </div>
        <div className="col-md-6 flex vertical-center right">
          <button
            style={{minWidth: 150, marginLeft: 10}}
            type="button"
            disabled={!selectedBalance}
            onClick={onPayBalanceOtherClick}
            className="btn btn-default btn-lg">
            {'Cash/Check'}
          </button>
          <button
            style={{minWidth: 150, marginLeft: 10}}
            type="button"
            disabled={!selectedBalance}
            onClick={onPayBalanceClick}
            className="btn btn-primary btn-lg">
            {'Credit Card'}
          </button>
        </div>
      </div>
      <DisplayIf condition={!!balance && (environment != 'PROD' && environment != 'PRODUCTION')} 
        className="custom-checkbox-container" 
        style={{ float: "right", paddingRight: 15 }}>
        <input type="checkbox"
          id="webHooks"
          checked={enabledWebHooks}
          onChange={event => onWebHooksClick(event.target.checked)}/>
        <label htmlFor="webHooks">
          Click here to process payments in real time.
        </label>
      </DisplayIf> 
    </Panel>
    <CaptainVirtualEntryOptionsContainer />
      <div className="form-group text-right animated fadeIn">
        <button className="btn btn-link"
          type="button"
          onClick={onCaptainDetailsLinkClick}>
          {'Back To Captain Details'}
        </button>
        {' '}
        <button
          type="button"
          className="btn btn-primary btn-lg"
          disabled={submitting}
          onClick={() => onSaveChangesClick(virtualEventId)}
        >{submitting ? <Submitting /> : null} {`Save Changes`}</button>
      </div>
      <ErrorListContainer />
      <VirtualEntryPaymentModalContainer />
      {virtualEntries && virtualEntries.length
        ? <div className="list-group">
            {virtualEntries.map((item, index) => (
              <VirtualEntryContainer
                key={index}
                {...item}
                bowlers={bowlers.filter(b => {
                  return item.bowlerId == b.id || !virtualEntries.some(e => {
                    return e.bowlerId == b.id ;
                  });
                })}
                teams={teams.filter(t => {
                  return item.entryId == t.id || !virtualEntries.some(e => {
                    return e.entryId == t.id ;
                  });
                })}
                position={index + 1}
              />
            ))}
          </div>
        : <div className="alert alert-info">{'No virtual entries to display.'}</div>
      }
    </DisplayIf>
  </div>
);

VirtualEntryList.propTypes = {
  virtualEventId: PropTypes.string.isRequired,
  virtualEntries: PropTypes.arrayOf(PropTypes.object),
  bowlers: PropTypes.arrayOf(PropTypes.object),
  teams: PropTypes.arrayOf(PropTypes.object),
  submitting: PropTypes.bool,
  balance: PropTypes.number,
  selectedBalance: PropTypes.number,
  onSaveChangesClick: PropTypes.func,
  onCaptainDetailsLinkClick: PropTypes.func,
  onPayBalanceClick: PropTypes.func,
  onPayBalanceOtherClick: PropTypes.func,
  enabledWebHooks: PropTypes.bool,
  onWebHooksClick: PropTypes.func,
  environment: PropTypes.string
};

VirtualEntryList.defaultProps = {
  virtualEntries: null,
  bowlers: [],
  teams: [],
  balance: 0,
  selectedBalance: 0
};

export default VirtualEntryList;



// WEBPACK FOOTER //
// ./src/features/admin/virtualEventDetail/VirtualEntryList.jsx